import {getUserPremiumLevel} from '@Libraries/user.library';
import {USER_PREMIUM_LEVELS} from '@Utils/user.util';

export interface NameInputProps {
  // add props here
}

export const NAME_LENGTH_LIMIT = 75;

export const isEventNameComplete = (name: string): boolean => {
  return name.trim() !== '';
};

export const shouldUpsellUserTypeAIGeneration = (): boolean => {
  return getUserPremiumLevel() === USER_PREMIUM_LEVELS.PAYG;
};
